// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"XJVw9W","Fullscreen":"TeBTvH"};